import GET_SIGNED_URL from '../../../../GraphQl/Queries/GET_SIGNED_URL';
import ReportProvider from '../../../../shared/ReportProvider';
import React from 'react';
import { useQuery } from 'react-apollo';

const EditorialDetailsPageViewLoader = ({ reportKey, ...props }) => {
  const {
    data: signedUrl,
    loading: signedUrlLoading,
    error: signedUrlError,
  } = useQuery(GET_SIGNED_URL, {
    variables: {
      key: reportKey,
    },
  });

  return (
    <ReportProvider
      signedUrl={
        signedUrl && signedUrl.hasOwnProperty('getSignedURL') ? signedUrl.getSignedURL : null
      }
    >
      {React.cloneElement(props.children, {
        ...props.children.props,
        signedUrlLoading,
        signedUrlError,
      })}
    </ReportProvider>
  );
};

export default EditorialDetailsPageViewLoader;
